import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';

import { AdminPage } from '../lib/admin_layout';
import ApiTokensLayoutContainer from './api_tokens_layout';
import connect from 'components/lib/connect';
import IntegrationsNav from 'components/admin/integrations/integrations_nav';

export function ApiTokensPage({ isEnabled, isSaving }) {
  return (
    <AdminPage showLoading={isSaving}>
      <IntegrationsNav>{isEnabled ? <ApiTokensLayoutContainer /> : null}</IntegrationsNav>
    </AdminPage>
  );
}

ApiTokensPage.propTypes = {
  isEnabled: PropTypes.bool.isRequired,
  isSaving: PropTypes.bool,
};

export default connect(mapStateToProps)(ApiTokensPage);

function mapStateToProps({ getProvider, isFeatureEnabled }) {
  return {
    isEnabled: isFeatureEnabled('devManagement'),
    isSaving: isSaving(),
  };

  function isSaving() {
    let apiTokensProvider = getProvider('apiTokens');

    return (
      apiTokensProvider.isPendingNew() ||
      _.some(apiTokensProvider.findAll(), apiToken => apiTokensProvider.isPending(apiToken.id))
    );
  }
}



// WEBPACK FOOTER //
// ./src/scripts/presentation/components/admin/api_tokens/api_tokens_page.jsx